import React from 'react';
import Button from '../../../../components/UI/Button';
import { Text } from '../../../../components/Typography/Typography';
import styles from './Pagination.module.scss';

interface Props {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  totalItems: number;
  itemsPerPage: number;
}

const Pagination: React.FC<Props> = ({
  currentPage,
  totalPages,
  onPageChange,
  totalItems,
  itemsPerPage,
}) => {
  // Handle edge cases where there are no items
  if (totalItems === 0) {
    return null;
  }

  // Calculate start and end items, ensuring we don't show invalid numbers
  const startItem = Math.min((currentPage - 1) * itemsPerPage + 1, totalItems);
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className={styles.container}>
      <Text size="small" color="neutral-600" className={styles.info}>
        Showing {startItem}-{endItem} of {totalItems} evaluations
      </Text>
      <div className={styles.controls}>
        <Button
          variant="outline"
          size="small"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <Text size="small" color="neutral-600" className={styles.pageInfo}>
          Page {currentPage} of {totalPages}
        </Text>
        <Button
          variant="outline"
          size="small"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
